export default function (Component) {
       if(!Component.options.wxsCallMethods){
         Component.options.wxsCallMethods = []
       }
       Component.options.wxsCallMethods.push('closeOther')
Component.options.wxsCallMethods.push('setState')
     }